import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import '../../../../filters';

export default {
  name: 'inputEngineeringInvestigationResults',
  components: {

  },
  props: ['dataObj'],
  data: function () {
    return {
      appId: -1,
      appData: {
        invDate: null,
        mainDistance: 0,
        mainSize: 0,
        mainType: null,
        peakFlow: 0,
        minFlow: 0,
        outcome: null
      },
      lang: '',

      mainTypes: [],
      outcomes: [],

      invDateView: null
    }
  },
  watch: {
    invDateView: function (val) {
      this.appData.invDate = moment(val, "DD/MM/YYYY").add(1, 'days');
    }
  },
  created() {
    this.$material.locale.dateFormat = 'dd/MM/yyyy';
    this.$root.$on('engineering_investigation_updated', this.init);
    this.init();
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.appId = this.dataObj.appId;
        this.appData = this.dataObj.appData;
        this.invDateView = this.$options.filters.formatDateDDMMYYY(this.appData.invDate);

        this.mainTypes = this.appData.mainTypes;
        this.outcomes = this.appData.outcomes;

        console.log(this.appData);
      });
    },
  },
}
